import { RegionCode } from './region';

export type LocaleCode = `${string}_${string}`;

export interface Locale {
  /**
   * Locale code e.g. en-US or es-MX.
   */
  locale: LocaleCode;

  /**
   * Language identifier e.g. en or es.
   */
  language: string;

  /**
   * Country identifier e.g. US or MX.
   */
  country: string;

  /**
   * Region identifier e.g. US, GB, FR or DE.
   */
  region: RegionCode;
}

export const defaultLocale: Locale = {
  locale: 'en_US',
  language: 'en',
  country: 'US',
  region: 'US',
};

export const languages = ['en', 'fr', 'es', 'de'];
